import React, { ReactElement, useState } from 'react';
import './ToggleSwitchComponent.scss';
import { useLocation } from 'react-router';
import { useRecoilState } from 'recoil';
import { etatUtilisateurConnecte } from '../../State';

interface ToggleSwitchProps {
    leftIcon?: ReactElement;
    rightIcon?: ReactElement;
    leftText: string;
    rightText: string;
    estActif?: boolean;
    setEstActif?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    leftText,
    rightText,
    leftIcon,
    rightIcon,
    estActif,
    setEstActif,
}) => {
    const initIsChecked = estActif ? estActif : false;
    const [isChecked, setIsChecked] = useState(initIsChecked);

    const toggleChecked = () => {
        setIsChecked(!isChecked);
        setEstActif && setEstActif(isChecked);
    };

    const [utilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);
    const location = useLocation();

    if (!(utilisateurConnecte.connecte && utilisateurConnecte.admin)) return <></>;

    if (
        !(
            location.pathname === '/dashboard/activites' ||
            location.pathname === '/activites' ||
            location.pathname === '/' ||
            location.pathname === '/recherche'
        )
    )
        return <></>;

    return (
        <div className="btn-container d-lg flex-grow-0" style={{ height: '40px' }}>
            <div className={`icons-left${!estActif ? ' checked' : ''}`}>
                {leftIcon && <div style={{ width: '20px' }}>{leftIcon}</div>}
            </div>
            <label className="switch btn-switch" htmlFor="switch">
                <input type="checkbox" name="switch" id="switch" onChange={toggleChecked} defaultChecked={estActif} />
                <label data-on={leftText} data-off={rightText} className="btn-switch-inner" htmlFor="switch"></label>
            </label>
            <div className={`icons-right${estActif ? ' checked' : ''}`}>
                {rightIcon && <div style={{ width: '20px' }}>{rightIcon}</div>}
            </div>
        </div>
    );
};

export default ToggleSwitch;
